import dayjs from 'dayjs';

const DATE_FORMAT = 'YYYY-MM-DD';
const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export function dateToMantineDateString(date: Date): string {
  return dayjs(date).format(DATE_FORMAT);
}

export function dateToMantineDateTimeString(date: Date): string {
  return dayjs(date).format(DATE_TIME_FORMAT);
}

export function dateToMantineTimeString(date: Date): string {
  return dayjs(date).format('HH:mm:ss');
}

export function isSameMantineCalendarDay(a: Date, b: Date): boolean {
  return dateToMantineDateString(a) === dateToMantineDateString(b);
}

export function mantineDateStringToDate(value: string | null): Date | null {
  if (value == null) {
    return null;
  }

  const dateOnly = dayjs(value, DATE_FORMAT, true);
  if (dateOnly.isValid() && !value.includes(':')) {
    // Local calendar date — must match dateToMantineDateString (dayjs local format).
    return dateOnly.toDate();
  }

  const dateTime = dayjs(value, DATE_TIME_FORMAT, true);
  if (dateTime.isValid()) {
    return dateTime.toDate();
  }

  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.toDate() : null;
}
